import { useMemo } from 'react'
import { Table, Row, ITableProps } from 'common-components'
import { ColumnsType } from 'antd/lib/table'
import { useNavigate } from 'react-router'
import { routes } from '@navigation/route-declarations'
import { ProjectAchievementType } from '@types'

type ContributorsTablePropsType = {
  projectsAchievement: ProjectAchievementType[]
  tableProps?: Partial<ITableProps<ProjectAchievementType>>
}
const ContributorsTable = ({
  projectsAchievement,
  tableProps = {},
}: ContributorsTablePropsType) => {
  const navigate = useNavigate()

  const tableColumns: ColumnsType<ProjectAchievementType> = useMemo(
    () => [
      {
        title: 'Nom du projet',
        dataIndex: 'name',
        key: 'name',
        render: (name: ProjectAchievementType['name']) => <Row align={'middle'}>{name}</Row>,
      },
      /* HIDE
			{
				title: "Temps effectif",
				dataIndex: "effectiveTime",
				key: "effectiveTime",
				render: (effectiveTime) => <Row align={"middle"}>{effectiveTime}</Row>,
			},
			{
				title: "Volume",
				dataIndex: "nbHits",
				key: "nbHits",
				render: (volume) => <Row align={"middle"}>{volume}</Row>,
			},
			{
				title: "Qualité",
				dataIndex: "quality",
				key: "quality",
				render: (quality) => (
					<Row align={"middle"}>
						{!!quality && <DotComponent activeDots={quality} />}
					</Row>
				),
			},*/
    ],
    [],
  )

  const onRowClick = useMemo(
    () => (record: ProjectAchievementType) => ({
      onClick: (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
        if (
          // record.accessLevel !== 'noAccess' &&
          !['checkbox'].includes((e.target as HTMLInputElement).name)
        ) {
          navigate(routes.contributor.navigate(record.idProject))
        }
      },
    }),
    [navigate],
  )

  return (
    <Table onRow={onRowClick} data={projectsAchievement} columns={tableColumns} {...tableProps} />
  )
}

export default ContributorsTable
